function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Clinical-Assessment",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clinical-Assessment-Detail",
  transform: "translate(-1357.000000, -245.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit",
  transform: "translate(1357.000000, 245.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "Combined-Shape",
  fill: "none",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "COLOR/-black",
  fill: "#FF7412"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0, 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C13.6568542,0 15,1.34314575 15,3 L15,3 L15,4 L19,4 C19.5128358,4 19.9355072,4.38604019 19.9932723,4.88337887 L20,5 C20,5.55228475 19.5522847,6 19,6 L19,6 L18,6 L18,19 C18,20.5976809 16.75108,21.9036609 15.1762728,21.9949073 L15,22 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,19 L2,6 L1,6 C0.487164161,6 0.0644928393,5.61395981 0.00672773133,5.11662113 L0,5 C0,4.44771525 0.44771525,4 1,4 L1,4 L5,4 L5,3 C5,1.40231912 6.24891996,0.0963391206 7.82372721,0.00509269341 L8,0 Z M16,6 L4,6 L4,19 C4,19.5128358 4.38604019,19.9355072 4.88337887,19.9932723 L5,20 L15,20 C15.5522847,20 16,19.5522847 16,19 L16,19 L16,6 Z M8,9 C8.55228475,9 9,9.44771525 9,10 L9,10 L9,16 C9,16.5522847 8.55228475,17 8,17 C7.44771525,17 7,16.5522847 7,16 L7,16 L7,10 C7,9.44771525 7.44771525,9 8,9 Z M12,9 C12.5522847,9 13,9.44771525 13,10 L13,10 L13,16 C13,16.5522847 12.5522847,17 12,17 C11.4477153,17 11,16.5522847 11,16 L11,16 L11,10 C11,9.44771525 11.4477153,9 12,9 Z M12,2 L8,2 C7.44771525,2 7,2.44771525 7,3 L7,3 L7,4 L13,4 L13,3 C13,2.48716416 12.6139598,2.06449284 12.1166211,2.00672773 L12,2 Z",
  id: "path-1"
}))))));

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.81296e40.svg";
export { ForwardRef as ReactComponent };